import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import Navbar from '../../components/Navbar'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import IndustriesStickyMenu from '../../components/IndustriesStickyMenu'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import immigration_img1 from "../../assets/images/contents/immigration_1.png"
import immigration_img2 from "../../assets/images/contents/immigration_2.svg"
import { PrimaryButton } from '../../components/StyledButtons'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const Immigrations = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const modalDiscussionRef = useRef(null);
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
  };
  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
    }
  };

  return (
    <div className='immigration bg-primary'>
      <div className='color-filter-right' style={{ top: "20%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "52%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid immigration-header pb-100'>
        <div className='container'>

          {language === "en" ?
            <div className='col-sm-10 col-sm-offset-1 pt-150'>
              <div className='font-weight-bold text-center font-64 immigration-header-title'>Immigration & Border Security</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
            :
            <div className='col-sm-10 col-sm-offset-1 pt-150'>
              <div className='font-weight-bold text-center font-64 immigration-header-title'>Nhập cư & An ninh Biên giới</div>
              <div className='col-sm-12'>
                <div className='underline-orange'></div>
              </div>
            </div>
          }
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.industries')} currentPage={t('bread-crumbs.immigration')} linkToPrevPage="/industries" />
          </div>
        </div>


      </div>
      <div className='immigration-content container'>
        <div className='row flex-lg'>
          <div className='col-lg-w-400'>
            <IndustriesStickyMenu governmentActive={true} immigrationActive={true} />
          </div>
          <div className='col-lg-w--400 immigration-content_info'>
            <p className='font-48 font-weight-semibold text-white'>{t('immigration.title')}</p>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('immigration.sub-title-1')}</p>
            <p className='text-white pt-20'>{t('immigration.content-1')}</p>
            <p className='text-white pt-20'>{t('immigration.content-2')}</p>
            <p className='text-white pt-20'>{t('immigration.content-3')}</p>
            <p className='text-white pt-20'>{t('immigration.content-4')}</p>
            <p className='text-white pt-20'>{t('immigration.content-5')}</p>
            <div className='pt-50'>
              <img src={immigration_img1} alt="" className='img-responsive' />
            </div>
            <p className='text-white pt-20 font-weight-medium font-20'>{t('immigration.sub-title-2')}</p>
            <p className='text-white pt-20'>{t('immigration.content-6')}</p>
            <p className='text-white pt-20'>{t('immigration.content-7')}</p>
            <div className='pt-50'>
              <img src={immigration_img2} alt="" className='img-responsive' />
            </div>
            <div className='col-sm-12 pt-30 px-0'>
              <ul className='list-unstyled pt-20'>
                <li className='checked-line'>{t('immigration.content-8-1')}</li>
                <li className='checked-line'>{t('immigration.content-8-2')}</li>
                <li className='checked-line'>{t('immigration.content-8-3')}</li>
                <li className='checked-line'>{t('immigration.content-8-4')}</li>
              </ul>
            </div>
            <div className='col-sm-12 pt-30'>
              <div className='row'>
                <PrimaryButton
                onClick={() => setModalDiscussionOpen(true)}
                >{t('button.schedule-discussion')}</PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <IndustriesImageContainer />
      </div>

      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default Immigrations